import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders, HttpResponse, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  Observable, Subject, forkJoin, of, throwError } from 'rxjs';
import { catchError, map, mergeMap, retry, tap  } from 'rxjs/operators';
import * as  _ from 'lodash';
import { DocumentSingleColumnQuery } from 'src/app/models/document-grid/DocumentSingleColumnQuery';
import { DocumentQuery } from 'src/app/models/document-grid/documentQuery';
import { environment } from 'src/environments/environment';
import { SearchCriteria } from 'src/app/models/document-grid/SearchCriteria';
import { MultipleDocumentsRequest } from 'src/app/models/document-grid/MultipleDocumentsRequest';
import { Redact } from 'src/app/models/document-grid/redact';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
@Injectable()
export class DocumentService {
private actioApinUrl: string;

public LoadEnabledDocumentActionsurl: string;
public endurl: string;
private dashboardApiUrl: string;
private firmflowApiUrl: string;
private fileChunkSize: number = 100;
allUserPermission: any;
exportValue: boolean = true;
connectionSpeed: string;
private booleanSource = new Subject<boolean>();
public currentBoolean = this.booleanSource.asObservable();

handleError(arg0: any): any {
    console.log('error occured');
 }
    constructor(private http: HttpClient,  ) {
       this.actioApinUrl = environment.base_api_uri ;
       
      this.endurl = environment.strrooturl;
      this.dashboardApiUrl = environment.base_dashboard_api_uri;
      this.firmflowApiUrl = environment.base_workflows_api_uri;
    }
    public LoadDocumentProperties<T>(fileCabinetId: string, drawerId: string): Observable<T> {
        return this.http.get<T>(this.actioApinUrl + 'FileCabinet/' +
         fileCabinetId  + '/Drawer/' + drawerId  + '/Documents/Properties?BypassCache=10f63c4f-79f2-4e46-abbc-dd0b93fa05c6' );
    }
    public LoadDocumentsForCopiedHyperlink(req) {
            return this.http.post(this.actioApinUrl + 'v1/documents/loadcopyhyperlink', JSON.stringify(req));
    }
    public getFilterData<T>(filterdata: DocumentSingleColumnQuery, searchType: string): Observable<T> {
      let options = { headers: {'searchType': searchType}};
      return this.http
          .post<T>(this.actioApinUrl + 'documents/v1/singlecolumnfilter', JSON.stringify(filterdata),options);
  }
    public LoadDocumentStatusess<T>(fileCabinetId: string,  drawerId: string): Observable<T> {
        return this.http
            .post<T>(this.actioApinUrl + fileCabinetId, JSON.stringify(drawerId));
    }
    public LoadDocuments<T>(documentQuery: DocumentQuery, searchType: string): any {


    let options = { headers: {'searchType': searchType}};
    let addinQueryStrings = this.getAddinQueryStrings();

     return this.http.post(this.actioApinUrl + `v1/documents/load?${addinQueryStrings}`, JSON.stringify(documentQuery), options );
}

public getOutlooktoken<T>(): any {
  const url = this.actioApinUrl + 'v1/user/outlooktoken';
    return this.http.get(url).pipe(
    map((res) => res),
    catchError((this.handleError)));
}
public getExportCSVData<T>(filterdata: DocumentSingleColumnQuery): Observable<T> {
  return this.http
      .post<T>(this.actioApinUrl + 'documents/export', JSON.stringify(filterdata));
}
public getMenuPermissions(req: any) {

  let permissionUrl;
  let isAddin = localStorage.getItem('IsAddin');
  let docType = localStorage.getItem('DocType');
  let insertLink = localStorage.getItem('InsertLink');
  let addinSourceType:string;
  if(docType==='0' && insertLink!=='1'){
    addinSourceType = 'AttachDocument';
  }else if(docType!=='0' && insertLink==='1'){
    addinSourceType = 'InsertLink';
  }else if(docType!=='0' && (insertLink==='null' || insertLink===null)){
    addinSourceType = 'OpenDocument';
  }else{
    addinSourceType = 'None';
  }
  if(isAddin==='null' || isAddin===null){
    permissionUrl = "/documents/menupermission";
  }else{
    permissionUrl = `/documents/addinmenupermission?addinSourceType=${addinSourceType}`;
  }

  let responseCopy;
  return this.http.post(this.actioApinUrl + 'v1'+ permissionUrl, JSON.stringify(req))
    .pipe(
      map((response) => {
        responseCopy = _.cloneDeep(response);
        let j = 0;
        response["menue"].forEach((element) => {
          if (element["name"] === "Send As Attachment") {
            responseCopy["menue"][j]["name"] = "Attach";
          }
          if (
            !(_.isUndefined(element["subMenu"]) || _.isNull(element["subMenu"]))
          ) {
            let i = 0;
            element["subMenu"].forEach((val) => {
              if (val["name"] === "Native Format") {
                val.name = "Native";
                responseCopy["menue"][j]["subMenu"][i]["name"] = "Native";
              } else if (val["name"] === "Single Zip file") {
                val.name = "Zip";
                responseCopy["menue"][j]["subMenu"][i]["name"] = "Zip";
              } else if (val["name"] === "Send as Link") {
                val.name = "Link";
                responseCopy["menue"][j]["subMenu"][i]["name"] = "Link";
              }
              i++;
              responseCopy["menue"].push(val);
            });
          }
          j++;
        });
        return responseCopy;
      })
    );
}
public UpadteFilterData<T>(searchCriteria: SearchCriteria) {
  return this.http.post(this.actioApinUrl + 'preferences/update', JSON.stringify(searchCriteria) );
}
public getApproveUnapprovedocuments<T>(docs: MultipleDocumentsRequest) {
  return this.http.post(this.actioApinUrl + 'v1/documents/status', JSON.stringify(docs));
}
public deletedocuments<T>(documentid: string[] , FileCabinet?: string , Drawer?: string ) {
 
      const options = {
        headers:  new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        body: documentid
      };
      return this.http.delete(environment.base_api_uri + 'v1/documents/delete',options);
    
}
public getArchiveUnarchivedocuments<T>(documents: MultipleDocumentsRequest ) {
  return this.http.post(this.actioApinUrl + 'v1/documents/status', JSON.stringify(documents));
 }
 public getExternalViewUsers<T>(drawerId: string , indexIds: string, documentIds: string[]) {

  let postBody = {
    DrawerId: drawerId,
    IndexIds: indexIds.split(","),
    DocIds: documentIds
  }
   return this.http.post(this.actioApinUrl + 'v1/documents/publish/externalusers', postBody).pipe(
      map((res:any) => res.users),
      catchError((this.handleError)));
 }



public deleteDocuments<T>(documentIds: string[]) {
  const url = _.template( this.actioApinUrl +
    'api/v1/documents/${documentIds}/delete');
    return this.http.delete(url({'documentId': documentIds})).pipe(
    map((res) => res),
    catchError((this.handleError)));
}
public copyDocuments<T>(copyDocumentsRequest: any) {
  return this.http.post(this.actioApinUrl + 'v1/documents/copy', JSON.stringify(copyDocumentsRequest));
}

public moveDocuments<T>(moveDocumentsRequest) {
  return this.http.post(this.actioApinUrl + 'v1/documents/move', JSON.stringify(moveDocumentsRequest));
}

public reindexDocuments<T>(reIndexDocuments) {
  return this.http.post(this.actioApinUrl + 'v1/documents/reindex', JSON.stringify(reIndexDocuments));
}

public publishUnpublishDocuments<T>(documents: MultipleDocumentsRequest) {
  return this.http.post(this.actioApinUrl + 'v1/documents/status', JSON.stringify(documents));
}
public  getdownloadData(documentid: string) : Observable<HttpResponse<any>> {
    return this.http.get(this.actioApinUrl + 'v1/documents/' + documentid + '/export' , {observe: 'response', responseType: 'arraybuffer'})
}
public  getdownloadMultiDocData <T>(multidocumentids: any) {
  return this.http.post(this.actioApinUrl + 'v1/documents/MultiDocExport' , JSON.stringify(multidocumentids),
   {responseType: 'arraybuffer'});
 }
public  getdrawerData <T>(fileCabinetId: string) {
  return this.http.get(this.dashboardApiUrl + '/fileroom/fileCabinet/' + fileCabinetId + '/drawers');
}
public emailUsingOutlookAsAttachment<T>() {
  return this.http.put(this.actioApinUrl + 'veDistribution',
   JSON.stringify({'CopiedSourceandDestinationDocumentIds': [], 'FailedDocumentIds': [], 'SuccessfulDocumentIds': ['00000002BK']}));
}

public emailUsingOutlookAsCompressed<T>() {
  return this.http.put(this.actioApinUrl + 'DocumentManagement//Documents/ApproveDistribution',
  JSON.stringify({'CopiedSourceandDestinationDocumentIds': [], 'FailedDocumentIds': [], 'SuccessfulDocumentIds': ['00000002BK']}));
}

public emailUsingOutlookAsHyperlink<T>() {
  return this.http.put(this.actioApinUrl + 'DocumentManagement/',
  JSON.stringify({'CopiedSourceandDestinationDocumentIds': [], 'FailedDocumentIds': [], 'SuccessfulDocumentIds': ['00000002BK']}));
}
public mergePdfs<T>(documentIds: string[]) {
  return this.http.post(this.actioApinUrl + 'v1/documents/mergePDFs', JSON.stringify(documentIds));
}

public appendPagestoPdf<T>() {
  return this.http.put(this.actioApinUrl + '/Documents/ApproveDistribution',
   JSON.stringify({'CopiedSourceandDestinationDocumentIds': [], 'FailedDocumentIds': [], 'SuccessfulDocumentIds': ['00000002BK']}));
}

public getClientPermissions(){
  return this.http.get(this.actioApinUrl + '/v1/documents/GetClientPermission');
}
getFirmFlowPermision(): Observable<any> { 
  const url = environment.base_api_uri + 'v1/administration/user/currentUser';
  return this.http.get<any>(url)
    .pipe(
      map((response) => {
        this.allUserPermission = response;
        return response;
      })
    );
}
public showDocumentHistory<T>(documentId: string[]) {
  const url = _.template( this.actioApinUrl +
    'v1/documents/${documentId}/history');
    return this.http.get(url({'documentId': documentId})).pipe(
    map((res) => res),
    catchError((this.handleError)));
}

public redact<T>(item: Redact) {
return this.http.post(this.actioApinUrl + 'v1/documents/redact', JSON.stringify(item));

}
public taxSort<T>(documentid: string[]) {
  return this.http.post(this.actioApinUrl + 'v1/documents/taxsort', JSON.stringify(documentid) );
}


public getDocumentPropertiesItems<T>(fileCabinetId: string, drawerId: string) {
  return this.http.get(this.actioApinUrl + 'DocumentManagement/FileCabinet/' +
  fileCabinetId  + '/Drawer/' + drawerId  + '/Documents/Properties');
}
public getdocumentstatus<T>( fileCabinetId: string, drawerId: string, documentid: string[])  {
  return this.http.post(environment.base_documents_api_uri + 'v1/documents/FileCabinet/' 
  + fileCabinetId  + '/Drawer/' + drawerId  + '/Status', JSON.stringify(documentid));
}

public getDocumentVersions(fileCabinetId: string, drawerId: string, documentId: string, rowCount = 100,
  totalRowCount = 100, approvedOnly = false, temp = Math.floor(Math.random() * 100)) {
 //Cache is not clearing in IE browser after delete operation. So temp variable is added to update the api everytime
   //To Do - This should be remove once we stop giving support to IE browser
return  this.http.get(environment.base_documents_api_uri + 'v1/documents/VersionControl?'+'fileCabinetID=' + fileCabinetId + '&drawerId=' + drawerId
+ '&documentId=' + documentId + '&rowCount=' + rowCount + '&totalRowCount=' + totalRowCount
+ '&approvedOnly=' + approvedOnly + '&temp=' +temp);
}
public deleteVersionsOfDocument(drawerId: string, documentId: string, versionNumbers: string[]) {

  const batchReq = [];
  _.forEach(versionNumbers, (d) => {
    batchReq.push(this.deleteVersionOfDocument(drawerId, documentId, d));
   });
  return forkJoin(batchReq );
 }

public deleteVersionOfDocument(drawerId: string, documentId: string, versionNumber: string) {

 return  this.http.delete(environment.base_documents_api_uri + 'v1/' + 'documents/' + documentId
  + '/versions/' + versionNumber, {});
}

getUserAccount(): Observable<any> {
  const url = environment.base_api_uri + 'v1/user/UserAccount';
  return this.http.get<any>(url)
    .pipe(
      map((response) => {
        return response;
      })
    );
}


/**
 * Below function is for identifying the filters from Addin in localStorage
 * Checks for isAddin =>null, 1
 * Checks for docType =>null, 0 (Outlook), 1(Word), 2(Excel)
 */
 getAddinQueryStrings(){
  let isAddin = localStorage.getItem('IsAddin');
  let docType = localStorage.getItem('DocType');
  let insertLink = localStorage.getItem('InsertLink');
  if(insertLink==='1'){
    docType = '0';
  }
  return `Isaddin=${isAddin}&Doctype=${docType}`;
}
public getExportList(request: any) {
  if (request.SortField === "") {
    request.SortField = 'doc_id';
  }
  
  let srchType = localStorage.getItem("searchview")=='1'? 'QuickSearch':'';

  const url = `${this.actioApinUrl}V1/documents/export`;
  return this.http.post(url, JSON.stringify(request), {headers:{'searchType': srchType }, responseType: 'arraybuffer'});
}

public setFirmflowStatus(): Observable<any>
{
  const apiUrl = `${this.firmflowApiUrl}StatusCheck`
  return this.http.get(apiUrl).pipe(
    catchError((error) => {
      console.log(error.statusText.toString())
      if(error.statusText.toString() === 'OK')
      {
        sessionStorage.setItem('firmflowEnabled', 'True')
      }else{
        sessionStorage.setItem('firmflowEnabled', 'False')
      }
      return 'True';
    })
  );
}

public getDocumentInfo(documentId: string, version: number): Observable<any> {
  const apiUrl = `${this.firmflowApiUrl}v2/LargeDocument/GetDocumentInfo?Version=${version}&DocumentId=${documentId}`;
  return this.http.get(apiUrl);
}

public getDownloadParts(documentId: string, fileSize: number, version: number): Observable<ArrayBuffer> {
  return this.startDocPartition(documentId, version, fileSize).pipe(
    mergeMap(response => {
      const fileURLS = response.body.data.parts;
      const responses$: Observable<ArrayBuffer>[] = [];
      let currentIndex = 0;
      const processNextChunk = () => {
        if (currentIndex < fileURLS.length) {
          const element = fileURLS[currentIndex];
          const queryString = element.resourceLocation.substring(element.resourceLocation.indexOf('?') + 1);
          return this.validateHashValuesForParts(queryString).pipe(
            retry(3),
            mergeMap(res => {
              if (res.data.toString() !== element.checkSum.toString()) {
                console.error("Hashes do not match. Aborting download.");
                return throwError("Hashes do not match. Aborting download.");
              } else {
                return this.getDocBytesFromApi(element.resourceLocation).pipe(
                  retry(3) 
                );
              }}),catchError(error => {
              console.error("Error downloading chunk:", error);
              return throwError("Error downloading chunk");
            }),mergeMap(pdfBytes => {
              responses$.push(of(pdfBytes));
              currentIndex++;              
              return processNextChunk();
            }));        
          } else 
          {
          return forkJoin(responses$);
        }
      };
      return processNextChunk();
    }),
    map(responses => {
      const mergedArrayBuffer = this.concatArrayBuffers(responses);
      return mergedArrayBuffer;
    }),
    catchError(error => {
      console.error("Error in downloading parts:", error);
      return throwError("Error in downloading parts");
    })
  );
}

public startDocPartition(documentId: string, version: number, fileSize: number): Observable<any> {
  const apiUrl = `${this.firmflowApiUrl}/LargeDocument/Download/Start`;
  const requestBody = {
    filePartSizeInMB: this.fileChunkSize,
    documentId: documentId.toString(),
    version: version
  };

  return this.http.post(apiUrl, requestBody, { 
    observe: 'response',
  }).pipe(
    map(response =>{
      return response
    })
  );
}

public finishDocumentExport(drawerId : string, cabinetId : string, documentName : string) : Observable<any>
{
  const apiUrl = `${this.firmflowApiUrl}v2/LargeDocument/Download/Finish`;
  const requestBody = {
    drawerId : drawerId,
    cabinetId : cabinetId,
    documentName : documentName
  };
  return this.http.post(apiUrl, JSON.stringify(requestBody));
}

private validateHashValuesForParts(apiParams : string): Observable<any> {
 var apiUrl = `${this.firmflowApiUrl}/LargeDocument/Download/Part/Hash?${apiParams}`
  return this.http.get<string[]>(apiUrl);
}

private getDocBytesFromApi(apiUrl: string): Observable<any> {
  return this.http.get(apiUrl, {  
  observe: 'response', 
  responseType: 'arraybuffer',
}).pipe(
    map(response =>  {
      return response}
      )
  );
}

private concatArrayBuffers(arrayBuffers: any): ArrayBuffer {
  const totalLength = arrayBuffers.reduce((acc, buffer) => acc + buffer.body.byteLength, 0);
  const result = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of arrayBuffers) {
    result.set(new Uint8Array(buffer.body), offset);
    offset += buffer.body.byteLength;
  }
  return result.buffer;
}

public updateBoolean(value: boolean) {
  this.booleanSource.next(value);
}

}